import unregisterServiceWorkers from '@/utils/unregisterServiceWorkers'
import Mtxs from '@/constants/Mutations'
import { version } from '@/../package'

export const state = {
  version,
  appVersionMismatch: false,
  isOnline: typeof navigator !== 'undefined' ? navigator.onLine : false,
} // state

export const mutations = {
  [Mtxs.SET_LATEST_VERSION](state, ver) {
    state.latestVersion = ver
  },
  [Mtxs.SET_APP_VERSION_MISMATCH](state, isMismatched) {
    state.appVersionMismatch = isMismatched
  },
  [Mtxs.SET_ONLINE_STATUS](state, status) {
    state.isOnline = status
  },
}

export const getters = {
  version: (state) => state.version,
  appVersionMismatch: (state, _, __, rootGetters) =>
    !!rootGetters['shop/getRequireVersionMatch'] && !!state.appVersionMismatch,
}

export const actions = {
  loadNewVersion({ getters }) {
    if (!getters.appVersionMismatch) {
      return false
    }
    let href = window.location.href
    window.location.href = href
  },
  setAppVersionMismatch({ commit }, isMismatched) {
    commit(Mtxs.SET_APP_VERSION_MISMATCH, isMismatched)
  }, // setAppVersionMismatch

  async resetApp() {
    try {
      await unregisterServiceWorkers()
    } finally {
      window.location.reload(true)
    }
  },

  setOnLineStatus({ commit }, isOnline) {
    commit(Mtxs.SET_ONLINE_STATUS, isOnline)
  }, // setOnLineStatus
}
